const defaultUrlsState = () => {
    return {
        CLIENT: process.env.VUE_APP_ROOT_CLIENT,
        MARKETPLACE: process.env.VUE_APP_ROOT_MARKETPLACE,
        FOMENTATION: process.env.VUE_APP_ROOT_FOMENTATION
    }
}
export default {
    namespaced: true,
    state: defaultUrlsState(),
    mutations: {
        setUrls(state, { CLIENT, MARKETPLACE, FOMENTATION }) {
            Object.assign(state, { CLIENT, MARKETPLACE, FOMENTATION })
        },
    },
    actions: {}
}